// Site Title
const getHeaderSiteTitle = () => document.title;

const setHeaderSiteTitle = provided => {
  if (document.title !== `Hero Builder | ${provided}`)
    document.title = `Hero Builder | ${provided}`;
};

export {getHeaderSiteTitle, setHeaderSiteTitle};
